
import React, {useState, useEffect} from 'react';
import {Navigate } from 'react-router-dom';
import Head from './head';
import Nav from './nav';
import './css/profile.css';
import './css/btn.css';
import Footer from './footer';
import Scripts from './scripts';

import {onAuthStateChanged} from "firebase/auth";

import {signInWithGoogle, auth} from './Firebase';


function Login (){
    const [loggedIn, setLoggedIn] = useState(false)

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setLoggedIn(!!user);
        });
        return unsubscribe;
    }, []);

    if(loggedIn){
        return <Navigate to="/"/>;
    }

    return (
		<div className="login">
			<Head/>
			<Nav/>
			<div className="auth-message">
				<h3>You must be signed in to view this page</h3>
				<button className="btn-primary" onClick={signInWithGoogle}>Log in</button>
			</div>
			<Footer/>
			<Scripts/>
		</div>
    )
}

export default Login;
